/**
 * created by yxy
 * 阵地维护
 */
import React from "react";
import BaseComponent from "../../../../../base/BaseComponent";
import {statisticsList} from '../config/config'


export default class Card extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }


    render() {
        let {item} = this.props;

        return (
            <div style={{
                width: "247px",
                height: "122px",
                borderRadius: "4px",
                background: "#fff",
                padding: '24px ',
                display: 'flex',
                border: "1px solid #00000026",
                marginBottom: '16px',
                alignItems: "center",
            }}>
                <div>
                    <img src={item.logo} style={{
                        width: "60px",
                        height: "60px"
                    }}/>
                </div>
                <div style={{
                    paddingLeft: '16px',
                    fontSize: "14px",
                    color: "#000000d9",
                    lineHeight: "25px",
                }}>
                    {item.viewVoInfo&&item.viewVoInfo.length&&item.viewVoInfo.map((i, ids) => {
                        let {name,color} ='';
                        statisticsList.forEach(every=>{
                            if(every.key === i.key){
                                name = every.name;
                                color = every.color
                            }
                        });
                        return (
                            <div key={ids}>
                                   <span style={{
                                       width: "8px",
                                       height: "8px",
                                       display: 'inline-block',
                                       borderRadius: '50%',
                                       marginRight: "4px",
                                       background: color
                                   }}>
                                   </span>
                                <span>{name}：</span>
                                <span>{i.num}</span>
                            </div>
                        )
                    })}


                </div>
            </div>
        );
    }
}